import { useState, useRef } from "react";
import { GetAllCompliances } from "@services/Compliance/Index";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";

export const useFetchByCode = () => {
  const [codeLoading, setCodeLoading] = useState(false);
  const hasFetchedRef = useRef(false);

  const {
    data: allCompliances,
    loading: loadingCompliances,
    fetchAllData,
  } = useFetchPaginatedData(GetAllCompliances);

  const isCodigoValido = (codigo) =>
    /^(PRJ|SRV)-\d{4}-\d{3}$/.test(codigo);

  const fetchByCode = async (codigo) => {
    setCodeLoading(true);

    if (!isCodigoValido(codigo)) {
      SweetAlert.error(
        "Formato de código inválido",
        "O código deve seguir o padrão PRJ-AAAA-NNN para um Projeto ou SRV-AAAA-NNN para um Serviço."
      );
      setCodeLoading(false);
      return null;
    }

    try {
      let dataToSearch = allCompliances;

      // ⚠️ Se for a primeira vez, aguarda retorno completo
      if (!hasFetchedRef.current || allCompliances.length === 0) {
        dataToSearch = await fetchAllData();
        hasFetchedRef.current = true;
      }

      const item = dataToSearch.find((item) => item.codigo === codigo);

      if (item) {
        SweetAlert.toastSuccess("Compliance associado!");
        return item;
      } else {
        SweetAlert.error(
          "Código não encontrado",
          "Nenhum compliance corresponde ao código informado. Verifique e tente novamente."
        );
        return null;
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      SweetAlert.error("Erro ao buscar dados", "Tente novamente mais tarde.");
      return null;
    } finally {
      setCodeLoading(false);
    }
  };

  return {
    fetchByCode,
    codeLoading: codeLoading || loadingCompliances,
  };
};
